import React from 'react';
import { Calendar } from 'lucide-react';

interface MetricValue {
  current: number;
  previous: number;
  diff: number;
  percent: number;
}

interface MetricCardProps {
  title: string;
  value: string | number;
  metric?: MetricValue;
  formatDiff?: (diff: number) => string;
}

export const MetricCard: React.FC<MetricCardProps> = ({
  title,
  value,
  metric,
  formatDiff,
}) => (
  <div className="bg-white rounded-lg border border-[#E5E5E5] p-4 flex flex-col">
    <div className="flex flex-col gap-2 mb-3">
      <span className="font-medium text-xs">{title}</span>
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <Calendar className="w-4 h-4" />
        Comparado ao período anterior
      </div>
    </div>
    <div className="flex flex-col min-w-0 flex-1">
      <span className="font-sans font-bold text-2xl text-gray-900">{value}</span>
      {metric && (
        <span className={`text-xs ${metric.diff >= 0 ? 'text-green-600' : 'text-red-600'}`}>
          {metric.diff >= 0 ? '+' : ''}{formatDiff ? formatDiff(metric.diff) : metric.diff}{' '}
          ({metric.percent >= 0 ? '+' : ''}{Math.round(metric.percent)}%) comparado ao período anterior
        </span>
      )}
    </div>
  </div>
);
